module.exports = "/_next/static/images/bg-red-seat-a0fd1d0c.png";